import FormValidationContainer from "../../Componant/FormControl/FormValidation";

const FormValidation = () => {
  return (
    <div className="page-body">
      <FormValidationContainer />
    </div>
  );
};

export default FormValidation;
